import { axiosInstance } from "../../../../Services";
import { MMH_PINCODE_PATH, USE_MOCK } from "./config";
import { mockGetLocationByPincode } from "../mock/mockApi";

// Resolves a 6-digit pincode to a "Locality [ST]" label for Client location.
//
// Goes through our own API rather than calling the postal service from the
// browser: the legacy form resolved it server-side too, and a cross-origin
// call from the panel depends on that service's CORS headers.
export const GetLocationByPincode = async (pincode) => {
  if (USE_MOCK) {
    return mockGetLocationByPincode(pincode);
  }
  return axiosInstance.get(`${MMH_PINCODE_PATH}/${pincode}`);
};

export default GetLocationByPincode;
